<figure class="highcharts-figure">
  <div id="bar"></div>
</figure>
